<template>
<div class="chapter">
<div class="inner_page">
<div class="Title_Page">
<h2 class="chaptitle3"><a id="page_31"></a><a href="#/006_Contents#ch11" id="rch11"><b>Know Your Butts</b></a></h2>
<p class="sub2an"><b>Lots of things that have nothing to do with rear ends are known as butts. Here’s a whole load of non-butt butts for you to ponder.</b></p>
<p class="sub2an">(Special thanks to BRI reader Seymour Butts for sending them in.)</p>
<div class="break">
<p class="imagela"><img alt="images" src="images/img_p40-1.jpg"/></p>
<p class="caption"><b>A mouth-watering butt roast</b></p>
</div>
<p class="noindent"><b><span class="font2">Butt Roast:</span></b> A particular cut of pork taken from the pig’s…shoulder.</p>
<p class="noindent"><b><span class="font2">Boston Butt:</span></b> This variation on the butt roast originated in Boston.</p>
<p class="noindent"><b><span class="font2">Butt Rubbing:</span></b> The practice of rubbing spices and other dry seasonings into a butt roast. (For Boston butts, the practice would be known as Boston butt rubbing.)</p>
<p class="noindent"><b><span class="font2">Butt Log:</span></b> A log cut from the lowest, widest part of a tree trunk, just above the stump, or “butt.”</p>
<p class="noindent"><b><span class="font2">Buttle:</span></b> A verb that describes what butlers do: They “buttle.”</p>
<div class="break">
<p class="imagela"><img alt="images" src="images/img_p40-2.jpg"/></p>
<p class="caption"><b>The inventor of Scrabble, Alfred Butts</b></p>
</div>
<p class="noindent"><b><span class="font2">Butts, Alfred Mosher:</span></b> The unemployed American architect who invented the board game Scrabble in 1938.</p>
<p class="noindent"><b><span class="font2">David Bensusan-Butt:</span></b> A wartime British civil servant and author of the Butt Report.</p>
<p class="noindent"><b><span class="font2">Water Butt:</span></b> The British name for a rain barrel.</p>
<div class="break">
<p class="imagela"><img alt="images" src="images/img_p41.jpg"/></p>
<p class="caption"><b>Major Archibald Butt, the biggest butt that went down with the <i>Titanic</i></b></p>
</div>
<p class="noindent"><b><span class="font2">Major Butt:</span></b> A military aide to presidents Teddy Roosevelt and William Howard Taft, Archibald Butt was present when Taft threw out the first presidential baseball in 1910. He was also onboard the <i>Titanic</i> when it struck an iceberg on April 14, 1912, and he went down with the ship.</p>
<p class="noindent"><b><span class="font2">The Butt Memorial Bridge:</span></b> A bridge in Augusta, Georgia, built in 1914 and dedicated to the memory of Major Butt.</p>
<p class="noindent"><b><span class="font2">Sackbut:</span></b> A style of trombone popular during the Renaissance and Baroque eras.</p>
<p class="noindent"><b><span class="font2">Butt Rot:</span></b> When the butt of a living tree suffers from a fungal infection, it’s said to have “butt rot.”</p>
<p class="noindent"><b><span class="font2">The Butt Report:</span></b> A secret World War II report critical of British bombers for an inability to hit their targets. The Butt Report spurred changes in tactics and technology that vastly improved bomber accuracy.</p>
<p class="centers"><b>URANUS SPINS ON ITS SIDE.</b></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 018_Chapter11.vue?4f2217cf